import * as React from "react";
import { Context } from "./auth-service-tools115.js";
import { invariantIntlContext } from "./auth-service-tools117.js";

function useIntl() {
  var intl = React.useContext(Context);
  invariantIntlContext(intl);
  return intl;
}

export { useIntl as default };